export const initialSelectedPoint = { lng: 13.388198546620572, lat: 52.55289914372827 };

export const initialBounds = {
	desktop: [
		[12.776438493936695, 52.33851047506644],
		[13.862704410977159, 52.678266240051556],
	],
	tablet: [
		[12.999107271216332, 52.2110887296096],
		[13.784109748234727, 52.73464303149882],
	],
	mobile: [
		[13.06474385747191, 52.233750209648724],
		[13.746617839488863, 52.728279541363736],
	],
};

export const initialPadding = {
	desktop: {
		top: 60,
		left: 130,
		bottom: 0,
		right: 0,
	},
	tablet: {
		top: 120,
		left: 0,
		bottom: 80,
		right: 0,
	},
	mobile: {
		top: 100,
		left: 0,
		bottom: 0,
		right: 0,
	},
};

export const paddingOnZoom = {
	desktop: {
		top: 0,
		left: 130,
		bottom: 0,
		right: 0,
	},
	tablet: {
		top: 120,
		left: 0,
		bottom: 300,
		right: 0,
	},
	mobile: {
		top: 0,
		left: 0,
		bottom: 350,
		right: 0,
	},
};

export const maxBounds = [
	[12.180232311625713, 51.32129844848395], // south west
	[14.681828464193688, 53.45668580240292], // north east
];

export const topicColumns = [
	["internationale politik", "buergerrechte, gleichstellung, diskriminierung"],
	["gedenken und erinnerung", "weltanschauung", "klima, umwelt und energie"],
	["gesundheit", "arbeits- und sozialpolitik", "verkehr", "bildung"],
	[
		"stadtentwicklung und wohnen",
		"parteipolitik und politische stroemungen",
		"kinder und jugend",
		"kultur",
		"wirtschaft",
	],
];
